import * as React from "react";
import { useParams } from "react-router-dom";
import { ChangePasswordController } from "@njoy/controller";
import { ChangePasswordView } from "./ui/ChangePasswordView";
import { ChangePasswordConfirmationModal } from "../../../components/modals/changePasswordConfirmationModal";

// Define NormalizedErrorMap type
type NormalizedErrorMap = { [key: string]: string };

export const ChangePasswordConnector: React.FC = () => {
  const { key } = useParams<{ key: string }>();
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <ChangePasswordController>
      {({ submit, loading, error }) => {
        // Adapter to convert controller's submit result to NormalizedErrorMap | null
        const submitAdapter = async (values: any): Promise<NormalizedErrorMap | null> => {
          const result = await submit(values);
          if (!result) return null;
          // Convert result.errors array to NormalizedErrorMap
          if (Array.isArray(result.errors)) {
            const errorMap: NormalizedErrorMap = {};
            result.errors.forEach(({ path, message }) => {
              errorMap[path] = message;
            });
            return errorMap;
          }
          return null;
        };

        return (
          <>
            <ChangePasswordView
              onFinish={() => setModalOpen(true)}
              token={key as any}
              submit={submitAdapter}
              loading={loading}
              error={error}
            />

            <ChangePasswordConfirmationModal
              visible={modalOpen}
              onCancel={() => setModalOpen(false)}
            />
          </>
        );
      }}
    </ChangePasswordController>
  );
};